export default __webpack_public_path__ + "static/media/flag.b61eb4eb.svg";